import { getDynamicSetting } from 'utils/dynamicSettings';

const serverUrl = getDynamicSetting('server_url');

const RULES_ENDPOINT = 'rules/v1';

export const BASE_URL = `${serverUrl}/${RULES_ENDPOINT}`;
